import { TextField } from '@mui/material';

interface ClientIdFieldProps {
  value: string;
  setValue: (value: string) => void;
}

function ClientIdField({ value, setValue }: ClientIdFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='Client ID'
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default ClientIdField;

